export enum CmpConfigFiltersField {
    DELEGATED_PARTNERS = "delegated_partners"
}
